export const types = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
};

export const sizes = {
  small: 'small',
  regular: 'regular',
  large: 'large',
};

export const arrows = {
  none: 'none',
  right: 'right',
  down: 'down',
  left: 'left',
};

export const arrowPositions = {
  start: 'start',
  end: 'end',
};

export const decorations = {
  none: 'none',
  underline: 'underline',
};
